<style>
</style>

<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-envelope-o mr-2"></i>{{Core.Definition.getDefinition('Courriel')}}
                </template>
                <DynamicForm
                        class="mt-3"
                        ref="dynamicFormEmail"
                        getRoot="/setting/messaging-email"
                        saveRoot="/setting/messaging-email"
                        :formStructure="dataFormStructures.email">
                    <slot slot="emailPreview">
                        <div class="text-right mb-3">
                            <b-button @click="onEmailPreviewClick" class="btn btn-light btn-sm">
                                {{Core.Definition.getDefinition('Actualiser')}}
                            </b-button>
                        </div>
                        <Request
                                ref="requestEmailPreview"
                                method="POST"
                                root="/setting/messaging-email-preview"
                                :onRequestSuccess="onRequestSuccessEmailPreview">
                            <slot slot="body">
                                <div v-html="dataEmailPreview"></div>
                            </slot>
                        </Request>
                    </slot>
                </DynamicForm>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-commenting mr-2"></i>{{Core.Definition.getDefinition('SMS')}}
                </template>
                <DynamicForm
                        class="mt-3"
                        ref="dynamicFormSMS"
                        getRoot="/setting/messaging-sms"
                        saveRoot="/setting/messaging-sms"
                        :formStructure="dataFormStructures.sms">
                </DynamicForm>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import DynamicForm from '../../../components/DynamicForm'
    import Request from '../../../components/Request'
    export default {
        name: 'SettingsMessaging',
        components: {
            DynamicForm,
            Request
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataEmailPreview: '',
                dataFormStructures: {
                    sms: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'fromNumber'
                                            }
                                        ]
                                    },
                                    {}
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'fromNumber',
                                type: Core.Value.typeText,
                                label: Core.Definition.getDefinition('Numéro de l\'expéditeur'),
                                value: ''
                            }
                        ]
                    },
                    email: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Apparence'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'senderName'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'senderEmail'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logo'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'logoWidth'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'primaryColor'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'textColor'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'outerBGColor'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'bgColor'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'footerTxt'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cards: [
                                            {
                                                key: 'emailPreview',
                                                caption: Core.Definition.getDefinition('Prévisualiser')
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'primaryColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Couleur primaire'),
                                value: {}
                            },
                            {
                                id: 'textColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Couleur du texte'),
                                value: {}
                            },
                            {
                                id: 'bgColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Couleur arrière-plan'),
                                value: {}
                            },
                            {
                                id: 'outerBGColor',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Couleur arrière-plan extérieur'),
                                value: {}
                            },
                            {
                                id: 'logo',
                                type: 'avatar',
                                label: Core.Definition.getDefinition('Logo'),
                                value: '',
                                cropperOptions:{
                                    movable: true,
                                    zoomable: true
                                }
                            },
                            {
                                id: 'logoWidth',
                                type: 'text',
                                label: Core.Definition.getDefinition('Largeur du logo'),
                                description: Core.Definition.getDefinition('EX: 100px ou 40%'),
                                value: ''
                            },
                            {
                                id: 'footerTxt',
                                type: Core.Value.typeText,
                                label: Core.Definition.getDefinition('Pied de page'),
                                value: ''
                            },
                            {
                                id: 'senderName',
                                type: Core.Value.typeText,
                                label: Core.Definition.getDefinition('Nom de l\'expéditeur'),
                                value: ''
                            },
                            {
                                id: 'senderEmail',
                                type: Core.Value.typeText,
                                label: Core.Definition.getDefinition('Courriel de l\'expéditeur'),
                                value: ''
                            }
                        ]
                    }
                }
            }
        },
        computed: {
        },
        methods: {
            onEmailPreviewClick() {
                let form = this.$refs.dynamicFormEmail.$refs.form.form
                this.$refs.requestEmailPreview.addArg('primaryColor', form.primaryColor, Core.Value.typeColor)
                this.$refs.requestEmailPreview.addArg('bgColor', form.bgColor, Core.Value.typeColor)
                this.$refs.requestEmailPreview.addArg('outerBGColor', form.outerBGColor, Core.Value.typeColor)
                this.$refs.requestEmailPreview.addArg('textColor', form.textColor, Core.Value.typeColor)
                this.$refs.requestEmailPreview.addArg('footerTxt', form.footerTxt, Core.Value.typeText)
                this.$refs.requestEmailPreview.addArg('senderName', form.senderName, Core.Value.typeText)
                this.$refs.requestEmailPreview.addArg('logo', form.logo, Core.Value.typeAvatar)
                this.$refs.requestEmailPreview.addArg('logoWidth', form.logoWidth, Core.Value.typeText)
                this.$refs.requestEmailPreview.request()
            },
            onRequestSuccessEmailPreview(data){
                if (data.emailPreview !== undefined) {
                    this.dataEmailPreview = data.emailPreview
                }
            }
        }
    }
</script>
